export type { TUseCentralizedCorporateNavigation } from './use-centralized-corporate-navigation';
export { useCentralizedCorporateNavigation } from './use-centralized-corporate-navigation';
